import { lazyRemoveMasterCategories } from 'owa-categories';
import { isCategoryInFavorites, lazyRemoveFavoriteCategory } from 'owa-favorites';
import { action } from 'satcheljs/lib/legacy';

export default action('deleteCategoryRow')(async function deleteCategoryRow(
    idToDelete: string,
    nameToDelete: string
) {
    if (isCategoryInFavorites(idToDelete)) {
        // If it's a favorite category, we need to await the favorite store update and then proceed removing the master categories
        const removeFavoriteCategory = await lazyRemoveFavoriteCategory.import();
        removeFavoriteCategory(idToDelete, 'CategoriesOptions');
    }

    lazyRemoveMasterCategories.importAndExecute([nameToDelete], 'CategoriesOptions');
});
